"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
require("./Navigation.css");
var Navigation = function () {
    var location = (0, react_router_dom_1.useLocation)();
    return ((0, jsx_runtime_1.jsx)("nav", { className: "navigation", children: (0, jsx_runtime_1.jsx)("div", { className: "nav-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "nav-links", children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/", className: "nav-link ".concat(location.pathname === '/' ? 'active' : ''), children: "Home" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/kit", className: "nav-link ".concat(location.pathname === '/kit' ? 'active' : ''), children: "Kit Demo" })] }) }) }));
};
exports.Navigation = Navigation;
